import type { ReactNode } from "react";
import { ChartsLoader } from "@/components/charts/ChartsLoader";
type ChartsLibrary = typeof import("recharts");

type MainChartProps = {
  children: (charts: ChartsLibrary) => ReactNode;
  fallback?: ReactNode;
  errorFallback?: ReactNode;
};

export default function MainChart({ children, fallback, errorFallback }: MainChartProps) {
  return (
    <ChartsLoader fallback={fallback} errorFallback={errorFallback}>
      {children}
    </ChartsLoader>
  );
}
